<template>
    <div class="content">
      <Hero></Hero>
      <NewLevel></NewLevel>
    </div>  
</template>

<script>
import Hero from '../components/Hero.vue'
import NewLevel from '../components/NewLevel.vue'


export default {  
    components: {
        Hero,
        NewLevel
    },
    data() {
    return {
    };
  },
  name: 'Home',
}
</script>

<style scoped>

</style>
